import React from 'react'
import { withRouter } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import LargeIconButton from 'components/theme/LargeIconButton'
import Add from '@material-ui/icons/Add'
import CloudUpload from '@material-ui/icons/CloudUpload'
import language from 'utils/vast-languagepack'

export default withRouter(({ history }) => (
  <Grid
  style={{ maxWidth: 900, margin: '0 auto', width: '100%'}}
  container
  spacing={24}
  justify="space-between"
>
  <Grid item xs={12}>
    <Typography variant="h5" gutterBottom>
      {language.contacts.add.emptyContact}{' '}
      <em>{language.contacts.add.emptyContact2}</em>{' '}
      {language.contacts.add.emptyContact3}{' '}
      <em>{language.contacts.add.emptyContact4}</em>{' '}
      {language.contacts.add.emptyContact5}
    </Typography>
  </Grid>
  <Grid item xs={6}>
    <LargeIconButton onClick={() => history.push('contacts/new')} Icon={Add}>
      {language.contacts.add.createContact}
    </LargeIconButton>
  </Grid>
  <Grid item xs={6}>
    <LargeIconButton
      onClick={() => history.push('/contacts/upload')}
      Icon={CloudUpload}
    >
      {language.contacts.add.bulkUpload}
    </LargeIconButton>
  </Grid>
</Grid>
))
